import { create } from "zustand";

const defaultTiles = [
  { id: "1", color: "#ff3939", seq: 1 },
  { id: "2", color: "#f0884e", seq: 2 },
  { id: "3", color: "#ffd130", seq: 3 },
  { id: "4", color: "#8ade63", seq: 4 },
  { id: "5", color: "#558fff", seq: 5 },
  { id: "6", color: "#9666fc", seq: 6 },
  { id: "7" },
  { id: "8" },
  { id: "9" },
  { id: "10" },
  { id: "11" },
  { id: "12" },
  { id: "13" },
  { id: "14" },
  { id: "15" },
  { id: "16" },
];

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function playSfx(index, mute, loadedAudio) {
  const audio = loadedAudio[index];
  if (audio) {
    audio.volume = mute ? 0 : 1;
    audio.play();
  }
}

let greyTimeoutId = null;

const useGameStore = create((set, get) => ({
  score: 0,
  multiplier: 1,
  tiles: [...defaultTiles],
  currSeq: 0,
  gameStatus: "menu",
  leaderboards: [],
  lowestTopScore: 0,
  showHighScoreForm: false,
  newHighScore: 0,
  leaderboardOpen: false,
  helpOpen: false,
  mute: false,
  loadedAudio: [],

  setLoadedAudio: (audio) => set({ loadedAudio: audio }),

  setMultiplier: (multiplier) => set({ multiplier }),

  fetchLeaderboard: async () => {
    const cached = localStorage.getItem("lb_cache");
    if (cached) {
      const { data, time } = JSON.parse(cached);
      const age = Date.now() - time;
      set({ leaderboards: data });
      if (age < 30000) {
        if (data.length > 0) {
          const sorted = [...data].sort((a, b) => a.score - b.score);
          set({ lowestTopScore: sorted[0].score });
        }
        return;
      }
    }

    try {
      const results = await fetch("../.netlify/functions/topscores").then((r) =>
        r.json(),
      );
      localStorage.setItem(
        "lb_cache",
        JSON.stringify({ data: results, time: Date.now() }),
      );
      if (results.length > 0) {
        const sorted = [...results].sort((a, b) => a.score - b.score);
        set({ leaderboards: results, lowestTopScore: sorted[0].score });
      } else {
        set({ leaderboards: results, lowestTopScore: 0 });
      }
    } catch (error) {
      console.error("Error fetching top scores:", error.message);
    }
  },

  _scheduleGrey: () => {
    clearTimeout(greyTimeoutId);
    const { multiplier } = get();
    greyTimeoutId = setTimeout(
      () => {
        set((s) => ({
          tiles: s.tiles.map((t) => ({
            ...t,
            color: "#d9d9d9",
            cursor: "pointer",
            pointerEvents: "auto",
          })),
        }));
      },
      3000 - (multiplier / 3) * 2000,
    );
  },

  _reshuffle: () => {
    const tiles = [...defaultTiles];
    shuffleArray(tiles);
    set({ tiles, currSeq: 0 });
    get()._scheduleGrey();
  },

  startGame: () => {
    const tiles = [...defaultTiles];
    shuffleArray(tiles);
    set({
      tiles,
      gameStatus: "playing",
      score: 0,
      currSeq: 0,
    });
    get()._scheduleGrey();
  },

  clickTile: (seq) => {
    const state = get();
    if (state.gameStatus !== "playing") return;

    const { currSeq, score, multiplier, lowestTopScore, mute, loadedAudio } =
      state;

    if (seq === currSeq + 1) {
      playSfx(currSeq, mute, loadedAudio);

      if (seq === 6) {
        setTimeout(() => playSfx(7, mute, loadedAudio), 250);
        set({ score: score + 1 * multiplier });
        get()._reshuffle();
      } else {
        set({ currSeq: seq, score: score + 1 * multiplier });
      }
    } else {
      playSfx(6, mute, loadedAudio);
      set({ currSeq: 0 });

      if (score > lowestTopScore) {
        set({ showHighScoreForm: true, newHighScore: score });
      } else {
        set({ gameStatus: "gameover" });
      }
    }
  },

  submitHighScore: (name) => {
    const { score } = get();
    set({ showHighScoreForm: false, gameStatus: "gameover" });
    fetch("../../.netlify/functions/addscore", {
      method: "POST",
      body: JSON.stringify({ name: name.trim(), score }),
    })
      .then(() => get().fetchLeaderboard())
      .catch((error) => console.error("Error:", error.message));
  },

  retry: () => {
    get().startGame();
  },

  goHome: () => {
    set({ gameStatus: "menu", score: 0 });
  },

  toggleLeaderboard: () =>
    set((s) => ({ leaderboardOpen: !s.leaderboardOpen })),

  toggleHelp: () => set((s) => ({ helpOpen: !s.helpOpen })),

  toggleMute: () => set((s) => ({ mute: !s.mute })),

  closeLeaderboard: () => set({ leaderboardOpen: false }),

  closeHelp: () => set({ helpOpen: false }),
}));

export default useGameStore;
